import React, { useEffect, useState } from 'react';

const WORK_TYPE_LABEL = {
  DRILLING:'Drilling', WIRE_SAW:'Wire Saw', BLASTING:'Blasting',
  BLADE_CUTTING:'Blade Cutting', OFFSET:'Offset Work',
  WASTE:'Waste Management', TRANSPORT:'Transport', OTHER:'Other Work'
};
const DIR_FULL = {N:'North',S:'South',E:'East',W:'West'};
const statusColor = s => s==='COMPLETED'?'#3B6D11':s==='ON_HOLD'?'#854F0B':'#185FA5';
const statusBg    = s => s==='COMPLETED'?'#EAF3DE':s==='ON_HOLD'?'#FAEEDA':'#E6F1FB';
const fmt      = d => { try{ return new Date(d).toLocaleDateString('en-IN',{weekday:'long',day:'numeric',month:'long',year:'numeric'}); }catch{ return d; }};
const fmtShort = d => { try{ return new Date(d).toLocaleDateString('en-IN',{day:'numeric',month:'short',year:'numeric'}); }catch{ return d; }};

export default function PrintWorkReportPage() {
  const [data, setData] = useState(null);

  useEffect(()=>{
    const stored = sessionStorage.getItem('printWorkReport');
    if(stored) {
      setData(JSON.parse(stored));
      setTimeout(()=>window.print(), 1000);
    }
  }, []);

  if(!data) return <div style={{padding:20,fontFamily:'Arial',textAlign:'center',marginTop:40}}>Loading report...</div>;

  const { sessions=[], filters={}, byDate={}, dates=[], totalEntries=0, completed=0, inProgress=0, onHold=0, wtBreakdown={}, viewMode='summary' } = data;

  return (
    <div style={{fontFamily:'Inter,Arial,sans-serif',fontSize:12,color:'#333',padding:'10mm',maxWidth:'297mm',margin:'0 auto'}}>
      <style>{`
        @media print {
          @page { margin:8mm; size:A4 landscape; }
          body { margin:0; }
          tr { page-break-inside:avoid; }
        }
        * { box-sizing:border-box; }
      `}</style>

      {/* Company Header */}
      <div style={{borderBottom:'3px solid #1e3a5f',paddingBottom:10,marginBottom:14,display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
        <div style={{display:'flex',alignItems:'center',gap:14}}>
          <img src="/TycheAbodes-logo1.png" alt="Logo" style={{width:52,height:52,objectFit:'contain',borderRadius:6}} onError={e=>e.target.style.display='none'}/>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:'#1e3a5f',fontFamily:'Inter,sans-serif',letterSpacing:0.5}}>TYCHE ABODES PRIVATE LIMITED</div>
            <div style={{fontSize:11,color:'#555',marginTop:2}}>No. 401, Ramani's Frazer Square,</div>
            <div style={{fontSize:11,color:'#555'}}>Near Head Post Office, Goods Shed Road, Coimbatore - 641001.</div>
            <div style={{fontSize:11,color:'#555',marginTop:1}}>📞 +91 94433 23246 &nbsp;|&nbsp; GSTIN: 33AAKCT5967G1ZY</div>
          </div>
        </div>
        <div style={{textAlign:'right',flexShrink:0}}>
          <div style={{fontSize:16,fontWeight:800,color:'#1e3a5f',textTransform:'uppercase',letterSpacing:1}}>Work Report</div>
          <div style={{fontSize:11,color:'#555',marginTop:4}}>Period: <strong>{fmtShort(filters.from)}</strong> to <strong>{fmtShort(filters.to)}</strong></div>
          {filters.direction && <div style={{fontSize:11,color:'#555'}}>Direction: <strong>{DIR_FULL[filters.direction]||filters.direction}</strong></div>}
          {filters.stage && <div style={{fontSize:11,color:'#555'}}>Stage: <strong>{filters.stage}</strong></div>}
          <div style={{fontSize:11,color:'#555'}}>Generated: <strong>{new Date().toLocaleDateString('en-IN')}</strong></div>
        </div>
      </div>

      {/* KPI Summary */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(5,1fr)',border:'1px solid #ddd',borderRadius:6,overflow:'hidden',marginBottom:14}}>
        {[
          ['Total Sessions', sessions.length, '#1e3a5f'],
          ['Work Entries',   totalEntries,    '#185FA5'],
          ['Completed',      completed,       '#3B6D11'],
          ['In Progress',    inProgress,      '#854F0B'],
          ['On Hold',        onHold,          '#C0392B'],
        ].map(([l,v,c],i)=>(
          <div key={i} style={{padding:'8px 12px',textAlign:'center',background:i%2===0?'#f8f9fc':'#fff',borderRight:i<4?'1px solid #ddd':'none'}}>
            <div style={{fontSize:22,fontWeight:700,color:c,fontFamily:'monospace'}}>{v}</div>
            <div style={{fontSize:9,color:'#666',textTransform:'uppercase',letterSpacing:'0.5px',marginTop:2}}>{l}</div>
          </div>
        ))}
      </div>

      {/* Work Type Breakdown */}
      {Object.keys(wtBreakdown).length > 0 && (
        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:700,color:'#1e3a5f',textTransform:'uppercase',letterSpacing:'1px',borderBottom:'2px solid #1e3a5f',paddingBottom:4,marginBottom:8}}>Work Type Breakdown</div>
          <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
            {Object.entries(wtBreakdown).map(([wt,cnt])=>(
              <div key={wt} style={{padding:'6px 14px',borderRadius:4,background:'#EAF3DE',border:'1px solid #B5D4A4',textAlign:'center'}}>
                <div style={{fontFamily:'monospace',fontSize:18,fontWeight:700,color:'#3B6D11'}}>{cnt}</div>
                <div style={{fontSize:10,color:'#555',marginTop:1}}>{WORK_TYPE_LABEL[wt]||wt}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Summary Table */}
      {viewMode==='summary' && dates.length > 0 && (
        <div style={{marginBottom:14}}>
          <div style={{fontSize:11,fontWeight:700,color:'#1e3a5f',textTransform:'uppercase',letterSpacing:'1px',borderBottom:'2px solid #1e3a5f',paddingBottom:4,marginBottom:8}}>Day-wise Summary</div>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:11}}>
            <thead>
              <tr style={{background:'#1e3a5f',color:'#fff'}}>
                <th style={{padding:'6px 8px',textAlign:'left'}}>Date</th>
                <th style={{padding:'6px 8px',textAlign:'center'}}>Sessions</th>
                <th style={{padding:'6px 8px',textAlign:'center'}}>Entries</th>
                <th style={{padding:'6px 8px',textAlign:'left'}}>Work Types</th>
                <th style={{padding:'6px 8px',textAlign:'center'}}>Completed</th>
                <th style={{padding:'6px 8px',textAlign:'center'}}>In Progress</th>
                <th style={{padding:'6px 8px',textAlign:'center'}}>On Hold</th>
                <th style={{padding:'6px 8px',textAlign:'left'}}>Block References</th>
              </tr>
            </thead>
            <tbody>
              {dates.map((date,i)=>{
                const d = byDate[date];
                if(!d) return null;
                const wtCounts = {};
                d.entries.forEach(e=>{ wtCounts[e.work_type]=(wtCounts[e.work_type]||0)+1; });
                return (
                  <tr key={i} style={{background:i%2===0?'#f8f9fc':'#fff',borderBottom:'1px solid #eee'}}>
                    <td style={{padding:'5px 8px',fontWeight:600,color:'#1e3a5f',whiteSpace:'nowrap'}}>{fmtShort(date)}</td>
                    <td style={{padding:'5px 8px',fontFamily:'monospace',textAlign:'center'}}>{d.sessions.length}</td>
                    <td style={{padding:'5px 8px',fontFamily:'monospace',textAlign:'center'}}>{d.entries.length}</td>
                    <td style={{padding:'5px 8px'}}>
                      {Object.entries(wtCounts).map(([wt,cnt])=>(
                        <span key={wt} style={{fontSize:9,padding:'1px 6px',borderRadius:20,background:'#E6F1FB',color:'#185FA5',marginRight:3,display:'inline-block',marginBottom:2}}>
                          {WORK_TYPE_LABEL[wt]||wt} ×{cnt}
                        </span>
                      ))}
                    </td>
                    <td style={{padding:'5px 8px',fontFamily:'monospace',color:'#3B6D11',fontWeight:600,textAlign:'center'}}>{d.entries.filter(e=>e.status==='COMPLETED').length||'—'}</td>
                    <td style={{padding:'5px 8px',fontFamily:'monospace',color:'#185FA5',textAlign:'center'}}>{d.entries.filter(e=>e.status==='IN_PROGRESS'||!e.status).length||'—'}</td>
                    <td style={{padding:'5px 8px',fontFamily:'monospace',color:'#854F0B',textAlign:'center'}}>{d.entries.filter(e=>e.status==='ON_HOLD').length||'—'}</td>
                    <td style={{padding:'5px 8px',fontSize:10,color:'#555'}}>{[...new Set(d.sessions.map(s=>s.block_reference).filter(Boolean))].join(', ')||'—'}</td>
                  </tr>
                );
              })}
              <tr style={{background:'#1e3a5f',color:'#fff',fontWeight:700}}>
                <td style={{padding:'6px 8px'}}>TOTAL</td>
                <td style={{padding:'6px 8px',textAlign:'center',fontFamily:'monospace'}}>{sessions.length}</td>
                <td style={{padding:'6px 8px',textAlign:'center',fontFamily:'monospace'}}>{totalEntries}</td>
                <td style={{padding:'6px 8px'}}>—</td>
                <td style={{padding:'6px 8px',textAlign:'center',fontFamily:'monospace'}}>{completed}</td>
                <td style={{padding:'6px 8px',textAlign:'center',fontFamily:'monospace'}}>{inProgress}</td>
                <td style={{padding:'6px 8px',textAlign:'center',fontFamily:'monospace'}}>{onHold}</td>
                <td style={{padding:'6px 8px'}}>—</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Detailed View */}
      {viewMode==='detailed' && dates.length > 0 && (
        <div>
          {dates.map((date,i)=>{
            const d = byDate[date];
            if(!d||d.entries.length===0) return null;
            return (
              <div key={i} style={{marginBottom:14,pageBreakInside:'avoid'}}>
                <div style={{background:'#1e3a5f',padding:'6px 14px',borderRadius:'6px 6px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <span style={{color:'#fff',fontWeight:700,fontSize:13}}>{fmt(date)}</span>
                  <span style={{color:'rgba(255,255,255,0.7)',fontSize:11}}>{d.entries.length} entries · {d.sessions.length} sessions</span>
                </div>
                <table style={{width:'100%',borderCollapse:'collapse',fontSize:11,border:'1px solid #ddd',borderTop:'none'}}>
                  <thead>
                    <tr style={{background:'#f0f4ff'}}>
                      {['Session #','Block','Direction','Stage','Supervisor','Shift','Work Type','Status'].map(h=>(
                        <th key={h} style={{padding:'5px 8px',textAlign:'left',fontWeight:600,color:'#1e3a5f',fontSize:10}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {d.entries.map((e,ei)=>(
                      <tr key={ei} style={{background:ei%2===0?'#f8f9fc':'#fff',borderBottom:'1px solid #eee'}}>
                        <td style={{padding:'4px 8px',color:'#1e3a5f',fontWeight:600,fontFamily:'monospace',fontSize:10}}>{e.session_number}</td>
                        <td style={{padding:'4px 8px'}}>{e.block_reference||'—'}</td>
                        <td style={{padding:'4px 8px'}}>{DIR_FULL[e.direction]||e.direction||'—'}</td>
                        <td style={{padding:'4px 8px'}}>{e.stage||'—'}</td>
                        <td style={{padding:'4px 8px'}}>{e.supervisor||'—'}</td>
                        <td style={{padding:'4px 8px'}}>{e.shift||'—'}</td>
                        <td style={{padding:'4px 8px',fontWeight:500}}>{WORK_TYPE_LABEL[e.work_type]||e.work_type}</td>
                        <td style={{padding:'4px 8px'}}>
                          <span style={{fontSize:10,padding:'1px 8px',borderRadius:20,fontWeight:600,background:statusBg(e.status||'IN_PROGRESS'),color:statusColor(e.status||'IN_PROGRESS')}}>
                            {(e.status||'IN_PROGRESS').replace('_',' ')}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      )}

      {/* Footer */}
      <div style={{borderTop:'2px solid #1e3a5f',paddingTop:8,marginTop:14,display:'flex',justifyContent:'space-between',fontSize:10,color:'#666'}}>
        <span>TYCHE ABODES PRIVATE LIMITED — Confidential</span>
        <span>Generated: {new Date().toLocaleString('en-IN')}</span>
      </div>
    </div>
  );
}